import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const WorkFlowFormService = {
  state: {},

  mutations: {},

  actions: {
    workflowFormPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowForm/page', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowFormTree({ commit }, type) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowForm/tree', { type: type }).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    workflowFormSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowForm/save', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowFormRemove({ commit }, ids) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowForm/remove', ids).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowFormUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflowForm/${params.id}/update`, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowFormSaveContent({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflowForm/${params.id}/saveForm`, params.formContent).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowFormGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + `workflowForm/getDetailsById/${id}`).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default WorkFlowFormService
